'use client';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import { logError } from '../../utils/logging.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false,
      error: null,
      errorInfo: null
    });
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      if (this.props.production) {
        console.error('ErrorBoundary:error', error);
        console.error('ErrorBoundary:errorInfo', errorInfo);
        logError(new Error("ErrorBoundary: ".concat(error === null || error === void 0 ? void 0 : error.toString(), " ").concat(errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack)));
      }
      this.setState({
        hasError: true,
        error: error,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        production = _this$props.production,
        title = _this$props.title,
        message = _this$props.message,
        Component = _this$props.component;
      var _this$state = this.state,
        error = _this$state.error,
        errorInfo = _this$state.errorInfo,
        hasError = _this$state.hasError;
      if (hasError) {
        return /*#__PURE__*/React__default.createElement("section", {
          className: "error-boundary"
        }, title && /*#__PURE__*/React__default.createElement("h1", null, title), message && /*#__PURE__*/React__default.createElement("p", null, message), Component && /*#__PURE__*/React__default.createElement(Component, null), !production && error && /*#__PURE__*/React__default.createElement("details", {
          open: true
        }, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, error.toString()), /*#__PURE__*/React__default.createElement("br", null), Boolean(errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) && (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack)));
      }
      return children;
    }
  }]);
  return ErrorBoundary;
}(Component);
_defineProperty(ErrorBoundary, "displayName", 'BricksErrorBoundary');

export { ErrorBoundary };
